import React, { useEffect } from 'react';
import DOMPurify from 'dompurify';
import { useNavigate, useParams } from 'react-router-dom';
import { NoticeNavigationArrow } from 'components/announcement/NoticeNavigationArrow';
import paths from 'router/paths';

import { useAnnouncementStore } from 'store/useAnnouncementStore';

import './NoticeDetail.scss';

export const NoticeDetail = () => {
    const { fetchAnnouncement } = useAnnouncementStore();
    const announcement = useAnnouncementStore((state) => state.announcement);
    const previousAnnouncement = useAnnouncementStore(
        (state) => state.previousAnnouncement
    );
    const nextAnnouncement = useAnnouncementStore(
        (state) => state.nextAnnouncement
    );

    const { seq } = useParams();

    const navigate = useNavigate();

    const fetchAnnouncementData = async (seq: string | undefined) => {
        if (!seq) {
            navigate(paths.ANNOUNCEMENT_PATH_ALL);
        } else {
            await fetchAnnouncement(seq);
        }
    };

    useEffect(() => {
        fetchAnnouncementData(seq);
    }, [seq]);

    return (
        <div className='notice-detail-container'>
            <div className='notice-detail-wrapper'>
                <div className='notice-title'>{announcement?.n_title}</div>
                <div className='notice-date'>{announcement?.reg_date}</div>
                <div
                    className='notice-detail'
                    dangerouslySetInnerHTML={{
                        __html: DOMPurify.sanitize(
                            announcement ? announcement.n_content : ''
                        ),
                    }}
                ></div>
            </div>

            <div className='navigation-wrapper'>
                {previousAnnouncement ? (
                    <NoticeNavigationArrow
                        direction='previous'
                        announcement={previousAnnouncement}
                    />
                ) : null}
                {nextAnnouncement ? (
                    <NoticeNavigationArrow
                        direction='next'
                        announcement={nextAnnouncement}
                    />
                ) : null}
            </div>
        </div>
    );
};
